import { Box, CircularProgress, Fade, styled } from "@mui/material";

export default function Loading({ loading }: { loading: boolean }) {
  const DisabledBackground = styled(Box)({
    width: "100%",
    height: "100%",
    position: "fixed",
    background: "#ccc",
    opacity: 0.5,
    zIndex: 1,
  });

  return (
    <>
      <Fade
        in={loading}
        style={{
          transitionDelay: loading ? "800ms" : "0ms",
        }}
        unmountOnExit
      >
        <CircularProgress
          size={70}
          sx={{
            position: "fixed",
            left: "calc(50% - 35px)",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        />
      </Fade>

      {loading && <DisabledBackground />}
    </>
  );
}
